export const paginas = [
    {
        "pagina":"art70",
        "titulo" : "Art. 70 Ley de Transparencia",
        "tipo" : "links",
        "links" : [
            {
             "nombre":"Art. 70 fracc. 01 inciso g (Tabla)",
              "link":"../../Transparencia/htm/a70_f01_g.htm"  
            },
            {
                "nombre":"Art. 70 fracc. 01 inciso g (Excel)",
                 "link":"../../Transparencia/xlsx/a70_f01_g.xlsx"  
            }

        ]
    },
    {
        "pagina":"paaas",
        "titulo" : "Programa Anual de Adquisiciones, Arrendamientos y Servicios",
        "tipo" : "links",
        "links" : [
            {
             "nombre":"PAAAS 2025",
              "link":"/Pag/paaas2025"  
            }
            

        ]
    },
    {
        "pagina":"paaas2025",
        "titulo" : "Programa Anual de Adquisiciones, Arrendamientos y Servicios 2025",
        "tipo" : "links",
        "links" : [
            {
             "nombre":"Formato 1",
              "link":"../../Transparencia/pdf/paaas2025/paaas2025_formato1.pdf"  
            },
            {
                "nombre":"Formato 2",
                 "link":"../../Transparencia/pdf/paaas2025/paaas2025_formato2.pdf"  
            },
            {
                "nombre":"Formato 3",
                 "link":"../../Transparencia/pdf/paaas2025/paaas2025_formato3.pdf"  
            },

        ]
    },
    {
        "pagina":"apps",
        "titulo" : "Descarga de aplicaciones",
        "tipo" : "links",
        "links" : [
            {
             "nombre":"NMV",
              "link":"itms-services://?action=download-manifest&url=https://s-seguridad.hidalgo.gob.mx/assets/descargas/nmv/manifest.plist"  
            },
            {
                "nombre":"Seguridad Privada Hidalgo",
                 "link":"itms-services://?action=download-manifest&url=https://s-seguridad.hidalgo.gob.mx/assets/descargas/segpriv/manifest.plist"  
               }

        ]
    },
    {
        "pagina":"informacionfinanciera",
        "titulo" : "Descargar Información Financiera SRFT",
        "tipo" : "links",
        "links" : [
            {
             "nombre":"Información Financiera",
              "link":"../../Transparencia/doc/InformacionFinancieraSRFT.docx"  
            }

        ]
    },
    {
        "pagina":"ligas",
        "titulo" : "Ligas de Interés",
        "tipo" : "links",
        "links" : [
            {
             "nombre":"Código de Conducta de la SSPH",
              "link":"../../Transparencia/doc/CodigoDeConductaSSP.pdf"  
            },
            {
                "nombre":"Código de Ética",
                 "link":"../../Transparencia/doc/CodigoDeEtica.pdf"  
            },
            {
                "nombre":"Sesiones del Comité de Ética y de Control",
                 "link":"../../Transparencia/doc/Actas COCODI-ETICA.zip"  
            },
            {
                "nombre":"PADA 2023",
                 "link":"../../Transparencia/doc/PADA.pdf"  
            },
            {
                "nombre":"Informe PADA 2023",
                 "link":"../../Transparencia/doc/Informe_PADA_2023.pdf"  
            },
            {
                "nombre":"PADA 2024",
                 "link":"../../Transparencia/doc/PADA_2024.pdf"  
            }

        ]
    },
    {
        "pagina":"cepci",
        "titulo" : "CEPCI",
        "tipo" : "links",
        "links" : [
            {
             "nombre":"Código de Conducta de la SSPH",
              "link":"../../Transparencia/doc/CodigoDeConductaSSP.pdf"  
            },
            {
                "nombre":"Código de Ética",
                 "link":"../../Transparencia/doc/CodigoDeEtica.pdf"  
            },
            {
                "nombre":"Protocolo para la recepción y atención de Quejas y/o Denuncias",
                 "link":"../../Transparencia/doc/ProtocoloDeDenuncias.pdf"  
            },
            {
                "nombre":"Sesiones del CEPCI",
                 "link":"/Pag/sesionescepci"  
            },
            {
                "nombre":"Manual de inducción de la SSPH",
                 "link":"/Pag/induccion"  
            },
            {
                "nombre":"Acta de Instalación del Comité de Ética",
                "link":"../../Transparencia/doc/ActaInstalacionEtica.pdf"  
            },
            {
                "nombre":"Directorio CEPCI",
                "link":"../../Transparencia/doc/DirectorioCEPCI.pdf"  
            },
            {
                "nombre":"Protocolo Cero",
                 "link":"/Pag/protocolocero"  
            },
            {
                "nombre":"Programa Anual 2024",
                 "link":"../../Transparencia/doc/PA_CEPCI2024.pdf"  
            },
            {
                "nombre":"Día de la Integridad 2024",
                 "link":"../../Transparencia/doc/DiaIntegridad2024.zip"  
            }

        ]
    },
    {
        "pagina":"sesionescepci",
        "titulo" : "Sesiones del CEPCI",
        "tipo" : "links",
        "links" : [
            {
             "nombre":"2023",
              "link":"../../Transparencia/doc/CEPCI2023.zip"  
            },
            {
                "nombre":"2024",
                 "link":"../../Transparencia/doc/CEPCI2024.zip"  
            }
        ]
    },
    {
        "pagina":"protocolocero",
        "titulo" : "Protocolo Cero",
        "tipo" : "links",
        "links" : [
            {
             "nombre":"Consejeros Protocolo Cero",
              "link":"../../Transparencia/doc/consejerosProtoCero.pdf"  
            },
            {
                "nombre":"Pronunciamiento Protocolo Cero",
                 "link":"../../Transparencia/doc/pronunciamientoProtoCero.pdf"  
            }
        ]
    },
    {
        "pagina":"cocodi",
        "titulo" : "COCODI",
        "tipo" : "links",
        "links" : [
            {
                "nombre":"Sesiones del COCODI 2023",
                 "link":"../../Transparencia/doc/Actas_COCODI-ETICA2023.zip"  
            },
            {
                "nombre":"Sesiones del COCODI 2024",
                 "link":"../../Transparencia/doc/Actas_COCODI-ETICA2024.zip"  
            },
            {
                "nombre":"Ambiente de control",
                 "link":"/Pag/ambiente"  
            },
            {
                "nombre":"Acta de Instalación del COCODI",
                 "link":"../../Transparencia/doc/ActaInstalacionCOCODI.pdf"  
            },
            {
                "nombre":"PTAR 2024",
                 "link":"../../Transparencia/doc/PTAR2024.pdf"  
            },
            {
                "nombre":"PTCI 2024",
                 "link":"../../Transparencia/doc/PTCI2024.pdf"  
            }

        ]
    },
    {
        "pagina":"ambiente",
        "titulo" : "Ambiente de Control",
        "tipo" : "links",
        "links" : [
            {
                "nombre":"Lineamientos de Recursos Humanos",
                 "link":"../../Transparencia/doc/LineamientosAdmonRH.pdf"  
            }
            

        ]
    },
    {
        "pagina":"induccion",
        "titulo" : "Manual de Inducción de la Secretaría de Seguridad Pública del Estado de Hidalgo",
        "tipo" : "links",
        "links" : [
            {
                "nombre":"Manual de Inducción SSPH",
                 "link":"../../Transparencia/doc/induccionSSPH.pdf"  
            },
            {
                "nombre":"Formato de aceptación del Manual de Inducción",
                 "link":"../../Transparencia/doc/manualinduccion.docx"  
            },
            {
                "nombre":"Ley Federal del Trabajo",
                 "link":"https://www.diputados.gob.mx/LeyesBiblio/pdf/LFT.pdf"  
            },
            {
                "nombre":"Reglamento Interior de la Secretaría de Seguridad Pública del Estado de Hidalgo.",
                 "link":"../../Transparencia/doc/ReglamentoInteriorSSPH.pdf"  
            },
            {
                "nombre":"Reglamento de Honor y Justicia de la Instituciones Policiales de la Secretaría de Seguridad Pública.",
                 "link":"http://periodico.hidalgo.gob.mx/?p=39284"  
            },
            {
                "nombre":"Ley General de Responsabilidades Administrativas.",
                 "link":"https://www.diputados.gob.mx/LeyesBiblio/pdf/LGRA.pdf"  
            },
            {
                "nombre":"Ley de Responsabilidades Administrativas del Estado de Hidalgo.",
                 "link":"http://www.congreso-hidalgo.gob.mx/biblioteca_legislativa/leyes_cintillo/Ley%20de%20Responsabilidades%20Administrativas%20del%20Estado%20de%20Hidalgo.pdf"  
            },
            {
                "nombre":"Protocolo Cero para la Prevención, Atención y Sanción del Acoso Sexual y/o Laboral y Hostigamiento Sexual y/o Laboral en la administración Pública del Estado de Hidalgo.",
                 "link":"https://periodico.hidalgo.gob.mx/?p=42213"  
            },

            {
                "nombre":"Ley de Seguridad Pública del Estado de Hidalgo.",
                 "link":"http://www.congreso-hidalgo.gob.mx/biblioteca_legislativa/leyes_cintillo/Ley%20de%20Seguridad%20Publica%20para%20el%20Estado%20de%20Hidalgo.pdf"  
            },
            {
                "nombre":"Ley de Transparencia y Acceso a la Información Pública del Estado de Hidalgo.",
                 "link":"Ley de Transparencia y Acceso a la Información Pública del Estado de Hidalgo."  
            },
            {
                "nombre":"Ley de Archivos para el Estado de Hidalgo. ",
                 "link":"http://www.congreso-hidalgo.gob.mx/biblioteca_legislativa/leyes_cintillo/Ley%20de%20Archivos%20para%20el%20Estado%20de%20Hidalgo181119.pdf"  
            },
            {
                "nombre":"Ley de General de Protección de Datos Personales en Posesión de Sujetos Obligados.",
                 "link":"http://www.congreso-hidalgo.gob.mx/biblioteca_legislativa/leyes_cintillo/Ley%20de%20Proteccion%20de%20Datos%20Personales%20en%20posesion%20de%20sujetos%20obligados.pdf"  
            },
            {
                "nombre":"Plan Estatal de Desarrollo.",
                 "link":"http://planestataldedesarrollo.hidalgo.gob.mx/"  
            },
            {
                "nombre":"Pronunciamiento de \"Cero Tolerancia\" a las conductas de acoso sexual y/o laboral y hostigamiento sexual y/o laboral de la Secretaría de Seguridad Publica del Gobierno del Estado de Hidalgo.",
                 "link":"../../Transparencia/doc/PronunciamientoCero.pdf" 
            }
            
            

        ]
    },
    {
        "pagina":"septimo",
        "titulo" : "Diagnóstico Séptimo Transitorio",
        "tipo" : "links",
        "links" : [
            {
             "nombre":"Diagnóstico Séptimo Transitorio",
              "link":"../../Transparencia/htm/2020/diagnostico.pdf"  
            }

        ]
    },
    {
        "pagina":"c5i",
        "titulo" : "Centro de Control, Comando, Comunicaciones, Cómputo, Coordinación e Inteligencia (C5i)",
        "tipo" : "imagencontacto",
        "imagen" : "../../assets/imgs/c5i.jpg",
        "ubicacion":"Carretera México-Pachuca, Kilometro 76+600, ejido Acayuca, Municipio de Zapotlan de Juárez, Hidalgo. CP. 42191",
        "tel":"771 717 4720"
    },
    {
        "pagina":"IFP",
        "titulo" : "Instituto de Formación Profesional (IFP)",
        "tipo" : "imagencontacto",
        "imagen" : "../../assets/imgs/ifp1.jpg",
        "ubicacion":"Carretera Pachuca - Palma Gorda Km. 0+500, Palma Gorda, Mineral de la Reforma, Hgo.",
        "tel":"771 717 4808",
        "links" : [
            {
             "nombre":"Misión y Visión",
              "link":"/Pag/misionIFP"  
            },
            {
                "nombre":"Convocatoria Policía Estatal 2024",
                 "link":"../../assets/pdf/convEstatal202401.pdf"  
               },
               {
                "nombre":"Convocatoria Policía Penitenciaria 2024",
                 "link":"../../assets/pdf/convPenitenciaria202401.pdf"  
               },
               {
                "nombre":"Revistas",
                 "link":"/Pag/revistas"  
               }

        ]

    },
    {
        "pagina":"misionIFP",
        "titulo" : "Misión y Visión del IFP",
        "tipo" : "textoscortos",

        "textos" : [
            {
                "titulo":"Misión",
                 "contenido":"Desarrollar y fortalecer la formación profesional del capital humano que conforma a las instituciones de Seguridad Pública, para que garanticen el orden, paz y legalidad permanentes en la entidad, mediante un trabajo efectuado con calidad, calidez, entrega y sentido humano en el marco de un estado de derecho."  
               },
               {
                   "titulo":"Visión",
                    "contenido":"Ser el área estratégica de conocimiento, profesionalización y desarrollo humano de las instituciones de Seguridad Pública, capaz de dar respuesta efectiva e inmediata a las demandas que, sobre seguridad pública hace la sociedad Hidalguense, por medio de la formación integral de personal profesional comprometido mediante un plan de vida y carrera."  
               },
   

        ]

    },
    {
        "pagina":"aviso",
        "titulo" : "Política de Privacidad de la Aplicación Móvil",
        "tipo" : "avisopriv",
        "app":"Llamada Segura",
        "imagen":"../../assets/imgs/logollamada.png"
    },
    {
        "pagina":"avisonmv",
        "titulo" : "Política de Privacidad de la Aplicación Móvil",
        "tipo" : "avisopriv",
        "app":"No Más Violencia",
        "imagen":"../../assets/imgs/logonmv.png"
    },
    {
        "pagina":"avisohgo",
        "titulo" : "Aviso de Privacidad",
        "tipo" : "avisoprivhgo"
    },
    {
        "pagina":"armonizacion",
        "titulo" : "Armonización Contable",
        "tipo" : "desplegables",
        "links" : [
            {
                "anio":"2021", 
                "trimestre":[
                   {
                       "nombre":"A partir del ejercicio 2021 el Secretariado Ejecutivo del Consejo Estatal de Seguridad Pública será el área responsable de generar y publicar la información correspondiente al \"Fondo de Aportaciones para la Seguridad Pública del Estado de Hidalgo\"",
                       "link":"#" 
                   }
                  
                ]
               },
           
            {
                "anio":"2020", 
                "trimestre":[
                   {
                       "nombre":"Primer Trimestre",
                       "link":"../../Transparencia/armonizacion/2020/1trim.zip" 
                   },
                   {
                       "nombre":"Segundo Trimestre",
                       "link":"../../Transparencia/armonizacion/2020/2trim.zip"
                   },
                   {
                       "nombre":"Tercer Trimestre",
                       "link":"../../Transparencia/armonizacion/2020/3trim.zip"
                   },
                   {
                       "nombre":"Cuarto Trimestre",
                       "link":"../../Transparencia/armonizacion/2020/4trim.zip"
                   },
                ]
               },
               {
                "anio":"2019", 
                "trimestre":[
                   {
                       "nombre":"Primer Trimestre",
                       "link":"../../Transparencia/armonizacion/2019/1trim.zip" 
                   },
                   {
                       "nombre":"Segundo Trimestre",
                       "link":"../../Transparencia/armonizacion/2019/2trim.zip"
                   },
                   {
                       "nombre":"Tercer Trimestre",
                       "link":"../../Transparencia/armonizacion/2019/3trim.zip"
                   },
                   {
                       "nombre":"Cuarto Trimestre",
                       "link":"../../Transparencia/armonizacion/2019/4trim.zip"
                   },
                ]
               },
               {
                "anio":"2018", 
                "trimestre":[
                   {
                       "nombre":"Primer Trimestre",
                       "link":"../../Transparencia/armonizacion/2018/1trim.zip" 
                   },
                   {
                       "nombre":"Segundo Trimestre",
                       "link":"../../Transparencia/armonizacion/2018/2trim.zip"
                   },
                   {
                       "nombre":"Tercer Trimestre",
                       "link":"../../Transparencia/armonizacion/2018/3trim.zip"
                   },
                   {
                       "nombre":"Cuarto Trimestre",
                       "link":"../../Transparencia/armonizacion/2018/4trim.zip"
                   },
                ]
               },
               {
                "anio":"2017", 
                "trimestre":[
                   {
                       "nombre":"Primer Trimestre",
                       "link":"../../Transparencia/armonizacion/2017/1trim.zip" 
                   },
                   {
                       "nombre":"Segundo Trimestre",
                       "link":"../../Transparencia/armonizacion/2017/2trim.zip"
                   },
                   {
                       "nombre":"Tercer Trimestre",
                       "link":"../../Transparencia/armonizacion/2017/3trim.zip"
                   },
                   {
                       "nombre":"Cuarto Trimestre",
                       "link":"../../Transparencia/armonizacion/2017/4trim.zip"
                   },
                ]
               },
               {
                "anio":"2016", 
                "trimestre":[
                   {
                       "nombre":"Primer Trimestre",
                       "link":"../../Transparencia/armonizacion/2016/1trim.zip" 
                   },
                   {
                       "nombre":"Segundo Trimestre",
                       "link":"../../Transparencia/armonizacion/2016/2trim.zip"
                   },
                   {
                       "nombre":"Tercer Trimestre",
                       "link":"../../Transparencia/armonizacion/2016/3trim.zip"
                   },
                   {
                       "nombre":"Cuarto Trimestre",
                       "link":"../../Transparencia/armonizacion/2016/4trim.zip"
                   },
                ]
               },
               {
                "anio":"2015", 
                "trimestre":[
                   {
                       "nombre":"Primer Trimestre",
                       "link":"../../Transparencia/armonizacion/2015/1trim.zip" 
                   },
                   {
                       "nombre":"Segundo Trimestre",
                       "link":"../../Transparencia/armonizacion/2015/2trim.zip"
                   },
                   {
                       "nombre":"Tercer Trimestre",
                       "link":"../../Transparencia/armonizacion/2015/3trim.zip"
                   },
                   {
                       "nombre":"Cuarto Trimestre",
                       "link":"../../Transparencia/armonizacion/2015/4trim.zip"
                   },
                ]
               },
            {
                "anio":"2014", 
                "trimestre":[
                   {
                       "nombre":"Primer Trimestre",
                       "link":"../../Transparencia/armonizacion/2014/1trim.zip" 
                   },
                   {
                       "nombre":"Segundo Trimestre",
                       "link":"../../Transparencia/armonizacion/2014/2trim.zip"
                   },
                   {
                       "nombre":"Tercer Trimestre",
                       "link":"../../Transparencia/armonizacion/2014/3trim.zip"
                   },
                   {
                       "nombre":"Cuarto Trimestre",
                       "link":"../../Transparencia/armonizacion/2014/4trim.zip"
                   },
                ]
               },
               {
                "anio":"2013", 
                "trimestre":[
                   {
                       "nombre":"Primer Trimestre",
                       "link":"../../Transparencia/armonizacion/2013/1trim.zip" 
                   },
                   {
                       "nombre":"Segundo Trimestre",
                       "link":"../../Transparencia/armonizacion/2013/2trim.zip"
                   },
                   {
                       "nombre":"Tercer Trimestre",
                       "link":"../../Transparencia/armonizacion/2013/3trim.zip"
                   },
                   {
                       "nombre":"Cuarto Trimestre",
                       "link":"../../Transparencia/armonizacion/2013/4trim.zip"
                   },
                ]
               }
            
        ]
    },
    {
        "pagina":"srft",
        "titulo" : "Información Financiera SRFT",
        "tipo" : "desplegables2",
        "links" : [
            {
                "anio":"2025", 
                "trimestre":[
                   {
                       "nombre":"Primer Trimestre",
                       "link":[
                        {
                            "tituloSrft":"Ejercicio del Gasto (descargable excel)",
                            "linkSrft":"../../Transparencia/srft/2025/SSPH_ejercicio_gasto_1_2025.xlsx" 
                        },
                        {
                            "tituloSrft":"Destino del Gasto (descargable excel)",
                            "linkSrft":"../../Transparencia/srft/2025/SSPH_destino_gasto_1_2025.xlsx" 
                        }
                       
                       ]
                   }
                  
                ]
               },
            {
                "anio":"2024", 
                "trimestre":[
                   {
                       "nombre":"Tercer Trimestre",
                       "link":[
                        {
                            "tituloSrft":"Ejercicio del Gasto (descargable excel)",
                            "linkSrft":"../../Transparencia/srft/2024/SSPH_ejercicio_gasto_3_2024.xlsx" 
                        },
                        {
                            "tituloSrft":"Destino del Gasto (descargable excel)",
                            "linkSrft":"../../Transparencia/srft/2024/SSPH_destino_gasto_3_2024.xlsx" 
                        }
                       
                       ]
                   },
                   {
                    "nombre":"Cuarto Trimestre",
                    "link":[
                     {
                         "tituloSrft":"Ejercicio del Gasto (descargable excel)",
                         "linkSrft":"../../Transparencia/srft/2024/SSPH_ejercicio_gasto_4_2024.xlsx" 
                     },
                     {
                         "tituloSrft":"Destino del Gasto (descargable excel)",
                         "linkSrft":"../../Transparencia/srft/2024/SSPH_destino_gasto_4_2024.xlsx" 
                     }
                    
                    ]
                },
                  
                ]
               }
               
               
            
        ]
    },
    {
        "pagina":"revistas",
        "titulo" : "Revista IFP",
        "tipo" : "desplegables",
        "links" : [

            {
                "anio":"2022", 
                "trimestre":[
                   {
                       "nombre":"Enero-Febrero",
                       "link":"/assets/pdf/ifp/IFPquinta.pdf" 
                   },
                   {
                       "nombre":"Marzo-Abril",
                       "link":"/assets/pdf/ifp/IFPsexta.pdf"
                   },
                   {
                       "nombre":"Mayo-Junio",
                       "link":"/assets/pdf/ifp/IFPseptima.pdf"
                   }
                  
                ]
               },
               {
                "anio":"2021", 
                "trimestre":[
                   {
                       "nombre":"Junio",
                       "link":"/assets/pdf/ifp/IFPjunio2021.pdf"
                   },
                   {
                       "nombre":"Julio",
                       "link":"/assets/pdf/ifp/IFPjulio2021.pdf"
                   }
                ]
               }

            
        ]
    }
    
    
    
]